import * as React from 'react'

const SvgSuitcase = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={72}
    height={120}
    viewBox="0 0 72 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Suitcase_svg__a)">
      <path
        d="M43.014 59.231h-13.41c-5.14 0-9.323-4.189-9.323-9.334V9.33c0-5.146 4.184-9.33 9.323-9.33h13.41c5.14 0 9.322 4.184 9.322 9.33v40.567c0 5.145-4.183 9.334-9.322 9.334ZM29.604 4.265a5.074 5.074 0 0 0-5.063 5.07V49.9a5.074 5.074 0 0 0 5.063 5.07h13.41a5.073 5.073 0 0 0 5.063-5.07V9.335a5.073 5.073 0 0 0-5.063-5.07h-13.41ZM18.275 120a5.342 5.342 0 0 0 5.338-5.346 5.343 5.343 0 0 0-5.338-5.346 5.343 5.343 0 0 0-5.339 5.346A5.342 5.342 0 0 0 18.275 120Z"
        fill="#440A78"
      />
      <path
        d="M18.275 116.192a1.537 1.537 0 0 0 0-3.075 1.537 1.537 0 0 0 0 3.075Z"
        fill="#E1CEFF"
      />
      <path
        d="M53.663 120a5.342 5.342 0 0 0 5.339-5.346 5.343 5.343 0 0 0-5.339-5.346 5.343 5.343 0 0 0-5.339 5.346A5.342 5.342 0 0 0 53.663 120Z"
        fill="#440A78"
      />
      <path
        d="M53.663 116.192a1.537 1.537 0 0 0 0-3.075 1.537 1.537 0 0 0 0 3.075Z"
        fill="#E1CEFF"
      />
      <path
        d="m62.13 98.34-.037-53.98c-.004-6.047-4.903-10.945-10.941-10.94l-40.218.027C4.895 33.452.004 38.357.008 44.403l.037 53.981c.004 6.047 4.903 10.945 10.942 10.941l40.218-.028c6.038-.004 10.93-4.909 10.926-10.956Z"
        fill="#AC94F0"
      />
      <path
        d="m71.992 98.34-.037-53.98c-.004-6.047-4.903-10.945-10.942-10.94l-40.218.027c-6.038.005-10.93 4.91-10.926 10.956l.038 53.981c.004 6.047 4.903 10.945 10.941 10.941l40.218-.028c6.039-.004 10.93-4.909 10.926-10.956Z"
        fill="#E1CEFF"
      />
      <path
        d="m65.224 43.851-2.13 57.718-2.13-57.718c-.042-2.899 4.303-2.913 4.26 0ZM20.833 43.851l-2.13 57.718-2.13-57.718c-.047-2.899 4.302-2.913 4.26 0ZM31.928 43.851l-2.13 57.718-2.13-57.718c-.047-2.899 4.303-2.913 4.26 0ZM43.029 43.851l-2.13 57.718-2.13-57.718c-.047-2.899 4.302-2.913 4.26 0ZM54.124 43.851l-2.13 57.718-2.13-57.718c-.047-2.899 4.303-2.913 4.26 0Z"
        fill="#7130C9"
      />
    </g>
    <defs>
      <clipPath id="Suitcase_svg__a">
        <path fill="#fff" d="M0 0h72v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSuitcase
